module.exports = __webpack_public_path__ + "img/ico-mail.b40f5c5c.svg";